<template>
    <card :bg="bg" class="o-card-video" :class="`o-card-video--${bg}`" modifier="video" :parallax="false">
        <template #inner>
            <div class="o-card-video__inner">
                <!-- title -->
                <div class="o-card-video__inner__title">
                    <prismic-rich-text :field="data.title_card" />
                </div>

                <div
                    v-if="data.img"
                    class="o-card-video__inner__img"
                    v-cursor.rotate="{ label: $t('shared.cursor.watch') }"
                    @click="openLightBox"
                >
                    <asset :image="data.img" />
                </div>
                <!-- copy -->
                <prismic-rich-text class="o-card-video__inner__copy" :field="data.description" />
            </div>
        </template>
        <template #behind> </template>
    </card>
    <!-- </div> -->
</template>

<script>
import Asset from "objects/Asset";
import Card from "components/Card";
import PrismicRichText from "objects/PrismicRichText";
export default {
    components: {
        Asset,
        Card,
        PrismicRichText
    },
    props: {
        bg: {
            type: String,
            required: false,
            default: "bright"
        },
        data: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            imageSize: 320
        };
    },
    methods: {
        openLightBox() {
            this.setLightBoxInfo();
            this.toggleLightBox();
        },
        setLightBoxInfo() {
            this.$store.commit("lightBox/UPDATE_YOUTUBE_ID", this.data.youtube_id[0].text);
            this.data.video_description
                ? this.$store.commit("lightBox/UPDATE_COPY", this.data.video_description)
                : this.$store.commit("lightBox/UPDATE_COPY", []);
        },
        toggleLightBox() {
            this.$store.commit("lightBox/TOGGLE_LIGHT_BOX", true);
        }
    }
};
</script>

<style lang="scss">
.o-card-video {
    display: flex;
    @media #{$breakpoint-horizontal} {
        min-width: 600px;
    }
    &--bright {
        color: $color-dark;
    }
    &__inner {
        @include cardCopy;
        display: flex;
        flex-direction: column;
        padding: var(--padding-content) var(--padding-content);

        @media #{$breakpoint-horizontal} {
            min-width: 600px;
            min-height: 620px; //
        }

        &__title {
            @include t3-heavy-bold;
            @include boldIsWhite;
            padding-top: var(--grid-gutter);
            padding-bottom: var(--grid-gutter-half);
        }
        &__copy {
            --padding: var(--grid-gutter-half) 0px 5rem 0px;
            padding: var(--padding);
            font-size: 20px;
            @media #{$breakpoint-horizontal} {
                --padding: var(--grid-gutter-half) 0px 5rem 0px;
            }
        }
        &__img {
            cursor: none !important; // we use a custom cursor on video hover
            overflow: hidden;
            aspect-ratio: 2 / 1;
            img {
                object-fit: cover;
                min-width: 100%;
                min-height: 100%;
            }
        }
    }
}
</style>
